export const ppfPartsSedan = {
  front_bumper: "images/simulator-images/sedan_/ppf/bumper_front.png",
  mirrors_doorcups: "images/simulator-images/sedan_/ppf/doorcups_mirrors.png",
  headlamps: "images/simulator-images/sedan_/ppf/headlamps.png",
  hood_fenders_full: "images/simulator-images/sedan_/ppf/hood_fenders_full.png",
  hood_fenders_partial:
    "images/simulator-images/sedan_/ppf/hood_fenders_partial.png",
  luggagearea: "images/simulator-images/sedan_/ppf/luggage_area.png",
  rockers: "images/simulator-images/sedan_/ppf/rockers.png",
  grille: "images/simulator-images/sedan_/ppf/grille.png",
  rear_bumper: "images/simulator-images/sedan_/ppf/bumper_rear.png",
  apillarsroofline: "images/simulator-images/sedan_/ppf/apillarroof.png",
};

export const ppfPartsTruck = {
  front_bumper: "images/simulator-images/truck_/ppf/bumperfront.png",
  mirrors_doorcups: "images/simulator-images/truck_/ppf/mirrors.png",
  headlamps: "images/simulator-images/truck_/ppf/hlamps.png",
  hood_fenders_full: "images/simulator-images/truck_/ppf/fullhood.png",
  hood_fenders_partial: "images/simulator-images/truck_/ppf/hoodfenders.png",
  rockers: "images/simulator-images/truck_/ppf/rockers.png",
  grille: "images/simulator-images/truck_/ppf/grille.png",
  rear_bumper: "images/simulator-images/truck_/ppf/bumperrear.png",
  apillarsroofline: "images/simulator-images/truck_/ppf/apillarroof.png",
  tailgate: "images/simulator-images/truck_/ppf/tailgate.png",
};

export const ppfPartsSuv = {
  front_bumper: "images/simulator-images/suv_/ppf/frontbumper.png",
  mirrors_doorcups: "images/simulator-images/suv_/ppf/mirrorsdoorcups.png",
  headlamps: "images/simulator-images/suv_/ppf/headlamps.png",
  hood_fenders_full: "images/simulator-images/suv_/ppf/fullhoodfenders.png",
  hood_fenders_partial: "images/simulator-images/suv_/ppf/hoodpartial.png",
  rockers: "images/simulator-images/suv_/ppf/rockers.png",
  grille: "images/simulator-images/suv_/ppf/grille.png",
  rear_bumper: "images/simulator-images/suv_/ppf/rearbumper.png",
  apillarsroofline: "images/simulator-images/suv_/ppf/apillarroof.png",
  luggagearea: "images/simulator-images/suv_/ppf/luggage.png",
};
